/*
 * As visualizações por dia do tópico (GET /api/discussions/{id}/canela-views),
 * guardadas por tópico enquanto a página está aberta — um cache em
 * memória: abrir e fechar o menu não refaz a requisição.
 */
import app from 'flarum/forum/app';
/** A janela do gráfico, em dias. */
export const VIEW_STATS_DAYS = 30;
const cache = new Map();
export function cachedViewStats(discussion) {
  return cache.get(String(discussion.id()));
}

/**
 * Sem nenhum dia gravado (o tópico é
 * de antes da contagem diária, ou a tabela ainda não existe), entra um dia só
 * — hoje — com o total do tópico.
 */
export function fetchViewStats(discussion, totalViews) {
  const key = String(discussion.id());
  const cached = cache.get(key);
  if (cached) return Promise.resolve(cached);
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/discussions/${key}/canela-views`,
    // `filter[days]`: a API do Flarum recusa um `?days=` solto.
    params: {
      filter: {
        days: VIEW_STATS_DAYS
      }
    }
  }).then(data => {
    const stats = Array.isArray(data?.stats) ? data.stats.map(stat => ({
      viewed_at: String(stat.viewed_at),
      views: Number(stat.views) || 0
    })) : [];
    const estimated = !stats.length;
    if (estimated) {
      stats.push({
        viewed_at: new Date().toISOString().split('T')[0],
        views: totalViews
      });
    }
    const result = {
      topic_id: Number(data?.topic_id) || Number(key),
      stats,
      estimated
    };
    cache.set(key, result);
    return result;
  });
}
const ONE_DAY = 86400000;
function utcDay(time) {
  const date = new Date(time);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

/**
 * A janela inteira do gráfico: os últimos 30 dias (ou desde a criação do
 * tópico, se ele for mais novo), com zero nos dias sem registro.
 *
 * A contagem por dia começa quando o recurso é ligado: um tópico
 * antigo, com milhares de visualizações, chegava com dois ou três dias e
 * mostrava só os números (ou um gráfico de três pontos), em vez do gráfico do
 * mês.
 */
export function fullWindow(stats, createdAt) {
  const today = utcDay(Date.now());
  // De 30 dias atrás até hoje, os dois inclusive: 31 dias no eixo.
  const windowStart = today - VIEW_STATS_DAYS * ONE_DAY;
  const created = createdAt ? utcDay(createdAt.getTime()) : windowStart;
  const start = Math.min(today, Math.max(windowStart, created));
  const byDay = new Map(stats.map(stat => [stat.viewed_at, stat.views]));
  const days = [];
  for (let day = start; day <= today; day += ONE_DAY) {
    const key = new Date(day).toISOString().split('T')[0];
    days.push({
      viewed_at: key,
      views: byDay.get(key) ?? 0
    });
  }
  return days;
}
flarum.reg.add('ramon-canela', 'forum/features/stats/views/viewStats', { VIEW_STATS_DAYS: VIEW_STATS_DAYS,cachedViewStats: cachedViewStats,fetchViewStats: fetchViewStats,fullWindow: fullWindow, });